'use es6';

import PreviewAPI from '../api/PreviewAPI';
import { ActionTypes } from '../constants/AppConstants';
var previewAPI = new PreviewAPI();
export default {
  previewWebsite: function previewWebsite(websiteUrl) {
    return function (dispatch) {
      dispatch({
        type: ActionTypes.FETCH_PREVIEW_STARTED
      });
      previewAPI.getDesktopPreview(websiteUrl).then(function (response) {
        return dispatch({
          type: ActionTypes.DESKTOP_WEBSITE_PREVIEWED,
          payload: response.responseJSON
        });
      }, function () {
        return dispatch({
          type: ActionTypes.DESKTOP_WEBSITE_PREVIEWED_ERROR
        });
      });
      previewAPI.getMobilePreview(websiteUrl).then(function (response) {
        return dispatch({
          type: ActionTypes.MOBILE_WEBSITE_PREVIEWED,
          payload: response.responseJSON
        });
      }, function () {
        return dispatch({
          type: ActionTypes.MOBILE_WEBSITE_PREVIEWED_ERROR
        });
      });
    };
  }
};